import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, FileFieldProps, CustomFieldProps } from '@/components/form-builder/form-builder.types';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { switchMap, finalize, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { PreviewPdfComponent } from '@/components/shared/preview-pdf/preview-pdf.component';

interface getPPMUploadDialogProps {
  store: PpmRepository;
  validate: () => void;
}
let currentObjectUrl: string | null = null;
export const getPPMUploadDialog = ({ store, validate }: getPPMUploadDialogProps): DialogObject => {
  const fileField: DynamicField<FileFieldProps> = {
    label: 'Modèle PPM',
    variant: FieldVariant.FILE,
    isRequired: true,
    class: 'max-w-md',
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: false,
      value: store.getNestedObservable<File[]>('upload', 'modelPpmFile'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('upload', 'modelPpmFile', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        if (currentObjectUrl) {
          URL.revokeObjectURL(currentObjectUrl);
          currentObjectUrl = null;
        }
        store.setNested('upload', 'modelPpmFile', []);
        const remainingFiles = store.getNested<File[]>('upload', 'modelPpmFile').filter(file => file.name !== event.file.name);
        if (remainingFiles.length > 0) {
          store.setNested('upload', 'modelPpmFile', remainingFiles);
        }
      },
      message: 'common.files.warn',
    },
  };

  const filePreviewField: DynamicField<CustomFieldProps> = {
    label: 'Aperçu du fichier',
    variant: FieldVariant.CUSTOM,
    isHidden: store.getNestedObservable<File[]>('upload', 'modelPpmFile').pipe(map((files: File[]) => !files || files.length === 0)),
    props: {
      component: PreviewPdfComponent,
      injectKeys: ['src'],
      src: store.getNestedObservable<File[]>('upload', 'modelPpmFile').pipe(
        switchMap((files: File[]) => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }

          if (!files || files.length === 0) {
            return of('');
          }

          const file = files[0];
          const url = URL.createObjectURL(file);
          currentObjectUrl = url;
          return of(url);
        }),
        finalize(() => {
          if (currentObjectUrl) {
            URL.revokeObjectURL(currentObjectUrl);
            currentObjectUrl = null;
          }
        })
      ),
    },
  };

  return {
    title: 'Téléversement',
    width: '90vw',
    actions: [
      {
        label: 'ppm.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [fileField],
                },
                {
                  fields: [filePreviewField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
